import React from "react";
import { generalAssessmentDetails, generalVideoDetails } from "../../constants";
import FormComponent from "../../../Common/FormComponent/FormComponent";
import UploadImageWrapper from "../../ImageUploadWrapper";
import ImageUploader from "../../../Common/ImageUploader";
import { useCreateElementContext } from "../Context/CreateElementContext";
import { ErrorLabel } from "../../ElementForm";
import Label from "../../../Common/Label/Label";
import { Box, Typography } from "@mui/material";

const VideoDetails = ({}) => {
  const { form, options, handleImage } = useCreateElementContext();

  return (
    <Box display="flex" gap={4} alignItems={"end"} mt={2}>
      <Box
        maxWidth={"750px"}
        flex={1}
        display={"flex"}
        flexDirection={"column"}
        gap={2}
      >
        {generalVideoDetails.map((item) => (
          <Box>
            <FormComponent
              config={item}
              form={form}
              key={item.id}
              otherOptions={options[item?.props?.optionsKey ?? item.id]}
            />
            <ErrorLabel label={form.errors[item.id]} />
          </Box>
        ))}
      </Box>

      <Box maxWidth={"750px"} flex={1} display={"flex"} flexDirection={"column"} gap={2}>
        <Box display={"flex"} gap={2}>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Label>Portrait thumbnail</Label>
            <UploadImageWrapper
              UploadComponent={ImageUploader}
              onUpload={handleImage("portrait")}
              url={form.getValue("thumbnail.portrait")}
            />
            <ErrorLabel label={form.errors["thumbnail.portrait"]} />
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Label>Landscape thumbnail</Label>
            <UploadImageWrapper
              UploadComponent={ImageUploader}
              onUpload={handleImage("landscape")}
              url={form.getValue("thumbnail.landscape")}
            />
            <ErrorLabel label={form.errors["thumbnail.landscape"]} />
          </Box>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          The thumbnail aspect ratio is 0.8 for portrait and 1.66 for landscape.
        </Typography>
      </Box>
    </Box>
  );
};

export default VideoDetails;
